<div class="skiplinks">
  <a href="#mainContent" target="_self" (click)="skiplinkClicked($event)">Zum Inhalt</a>
  <a href="#footer" (click)="skiplinkClicked($event)">Zum Footer</a>
</div>

<brt-header *ngIf="currentPageLayout === PageLayout.DEFAULT || currentPageLayout === PageLayout.NOT_FOUND"></brt-header>
<brt-mobile-header *ngIf="currentPageLayout === PageLayout.DEFAULT || currentPageLayout === PageLayout.NOT_FOUND"></brt-mobile-header>
<brt-mobile-game-header-menu *ngIf="isGameArea"></brt-mobile-game-header-menu>
<brt-sub-navigation *ngIf="(showSubNavigation && currentPageLayout === PageLayout.DEFAULT) || currentPageLayout === PageLayout.ROOKIE" [showArchiveSort]="showArchiveSort"></brt-sub-navigation>

<div class="app__background">
  <div class="noise-bg"></div>
  <div class="anim-blobs">
    <div class="blob-1"></div>
    <div class="blob-2"></div>
    <div class="blob-3"></div>
  </div>
</div>

<div class="app__router-wrapper" id="mainContent" tabindex="-1">
  <router-outlet></router-outlet>
</div>

<div class="app__footer" *ngIf="currentPageLayout === PageLayout.DEFAULT || currentPageLayout === PageLayout.SIDE" [ngClass]="{'side': currentPageLayout === PageLayout.SIDE}">
  <brt-footer></brt-footer>
</div>
<!--<div class="container-fluid" *ngIf="showDefaultHeaderFooter && showFooter">-->
<!--  <div class="row">-->
<!--    <div class="col-12 col-md-10 offset-md-1 col-lg-12 offset-lg-0">-->
<!--      -->
<!--    </div>-->
<!--  </div>-->
<!--</div>-->


<brt-overlay></brt-overlay>
<brt-notifications-container></brt-notifications-container>
